export default __webpack_public_path__ + "static/media/login_facebook.3851140e.svg";